<template>
  <Poptip v-model="visible" class="c-pick" placement="bottom-start" @on-popper-show="updateColor">
    <div class="color-box">
      <span :style="colorBox"></span>
    </div>
    <div slot="content">
      <Chrome v-model="colors"></Chrome>
      <div class="c-btns">
        <Button type="text" size="small" @click="visible = false">取消</Button>
        <Button type="primary" size="small" @click="ok">确定</Button>
      </div>
    </div>
  </Poptip>
</template>
<script>
import { Chrome } from 'vue-color'
export default {
  name: 'colorPick',
  components: { Chrome },
  props: {
    value: {
      type: String
    }
  },
  computed: {
    colorBox() {
      return {
        backgroundColor: this.value
      }
    }
  },
  methods: {
    updateColor() {
      this.colors = JSON.parse(JSON.stringify(this.value))
    },
    ok() {
      if (this.colors && this.colors.rgba) {
        const { rgba } = this.colors
        this.$emit('input', `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${rgba.a})`)
      } else if (typeof this.colors === 'string') {
        this.$emit('input', this.colors)
      }
      this.visible = false
    }
  },
  watch: {
    value(nVal) {
      if (nVal) this.updateColor()
    }
  },
  data() {
    return {
      colors: '',
      visible: null
    }
  }
}
</script>
<style lang="scss" scoped>
.c-pick {
  position: relative;
  z-index: 9;

  .color-box {
    width: 60px;
    height: 20px;
    border: solid 1px #d8d8d8;
    transform: translateY(4px);
    cursor: pointer;

    span {
      display: inline-block;
      width: 100%;
      height: 100%;
      border-style: solid;
      border-color: #fff;
      border-width: 3px;
    }
  }

  .c-btns {
    width: 100%;
    background-color: #ffffff;
    text-align: right;

    button {
      margin-left: 8px;
    }
  }
}
</style>
